import React, { Component } from 'react';

// import CoreServices from './core-services/CoreServices';
import Contact from './Contact';
import Footer from './Footer';
import MainHeader from './MainHeader';
import Navigation from './Navigation';
import PartnerSlider from './partner-slider/PartnerSlider';
import PurposeAndStory from './PurposeAndStory';
import Services from './Services';
import TopBar from './TopBar';

class App extends Component {
  render() {
    return (
      <div id="home">
        <TopBar />
        <Navigation />
        <MainHeader className="handshake" />
        <PurposeAndStory />
        <Services />
        <Contact />
        <PartnerSlider />
        <Footer />

        </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js